import { styled } from '@nykaa/ui-components';

const FloatingWrapper = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.white};
  bottom: 16px;
  left: 48px;
  position: fixed;
  z-index: 9;
  border-radius: ${({ theme }) => theme.borders.radius30};
  border: 1px solid ${({ theme }) => theme.colors.primary10};
  align-items: center;
  padding: ${({ theme }) => theme.spacing.spacing40};
  max-width: 308px;
  flex-shrink: 0;
  box-shadow: ${({ theme }) => theme.elevations.shadow300};
`;

const QrImage = styled.img`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  margin-right: ${({ theme }) => theme.spacing.spacing40};
  position: relative;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleXSmall};
`;

const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.subTitleSmall};
  width: 90%;
  height: 32px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

const PhoneImageWrapper = styled.img`
  width: 50px;
  height: 45px;
  flex-shrink: 0;
  bottom: 0px;
  right: 0px;
  position: absolute;
  background: ${({ theme }) => theme.colors.white};
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 1;
  pointer-events: auto;
  transition: opacity 0.2s;
  background: ${({ theme }) => theme.colors.white};
`;

const RightFixedBox = styled.div`
  width: 32px;
  height: 60px;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-shrink: 0;
`;

export {
  FloatingWrapper,
  QrImage,
  Content,
  Title,
  Subtitle,
  PhoneImageWrapper,
  CloseButton,
  RightFixedBox,
};
